import { createFileRoute } from '@tanstack/react-router'
import DateRangePickerWithPresets from '@/components/inputs/DateRangePickerWithPresets'
import { RangeValue, DateValue } from '@heroui/react'
import { useState } from 'react'
import dayjs from 'dayjs'
import { parseDate } from '@internationalized/date'
import WeatherCharts from '@/components/field/insights/WeatherCharts'

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/insights/weather',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const [dateRange, setDateRange] = useState<RangeValue<DateValue> | null>({
    start: parseDate(dayjs().subtract(2, 'weeks').format('YYYY-MM-DD')),
    end: parseDate(dayjs().format('YYYY-MM-DD')),
  })

  return (
    <div className="flex flex-col gap-2">
      <DateRangePickerWithPresets value={dateRange} onChange={setDateRange} label="Date Range" />
      <WeatherCharts dateRange={dateRange} setDateRange={setDateRange} />
    </div>
  )
}
